class AppConfig {
  isDev() {
    return true;
  }
}

let _instance = new AppConfig();

export default _instance;